import { Injectable } from '@angular/core';

@Injectable()
export class SharedService {
    hasAuthorized = false;
    email = '';
    giftId: any;
    code: any;
}


// WEBPACK FOOTER //
// ./src/app/card/shared/shared.service.ts